module.exports = __webpack_public_path__ + "arr_l.d9038356.png";